import React, { useState, useEffect } from "react";
import { FaBookOpen, FaEdit, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { hasPermission } from "../../utils/authUtils"; // Import the utility
import { apiFetch } from "../../utils/api";
import { showError } from "../../utils/toast";

export default function TaskList() {
  const navigate = useNavigate();
  const [books, setBooks] = useState([]);
  const API_URL = process.env.REACT_APP_API_URL;

  // Check permissions
  const canEditBooks = hasPermission('book:update') || hasPermission('book:update:all');
  const canDeleteBooks = hasPermission('book:delete') || hasPermission('book:delete:all');
  const canViewBooks = hasPermission('book:read') || hasPermission('book:read:all');

  // Check token and redirect if missing
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/unauthorized?from=' + encodeURIComponent(window.location.pathname));
    }
  }, [navigate]);

  // Fetch existing books on load only if user has permission
  useEffect(() => {
    if (canViewBooks) {
      apiFetch(`${API_URL}/books`)
        .then((res) => res.json())
        .then((data) => setBooks(data))
        .catch((err) => console.error(err));
    }
  }, [canViewBooks]);

  const handleDelete = async (id) => {
    if (!canDeleteBooks) {
      showError("You don't have permission to delete books");
      return;
    }
    
    try {

      await apiFetch(`${API_URL}/books/${id}`, { method: "DELETE" });
      setBooks((prev) => prev.filter((b) => b.id !== id));
    } catch (error) {
      console.error("❌ Delete failed:", error);
    }
  };

  const handleEdit = (book) => {
    if (!canEditBooks) {
      showError("You don't have permission to edit books");
      return;
    }
    navigate("/create-book", { state: { book } });
  };

  if (!canViewBooks) {
    return (
      <div style={{ paddingLeft: "150px", paddingRight: "150px", textAlign: "center", marginTop: "50px" }}>
        <h3>Access Denied</h3>
        <p>You don't have permission to view books.</p>
      </div>
    );
  }

  return (
    <div style={{ paddingLeft: "150px", paddingRight: "150px" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "20px",
          justifyContent: "center",
        }}
      >
        <FaBookOpen
          style={{ fontSize: "50px", color: "#00008B", marginRight: "15px" }}
        />
        <span style={{ fontSize: "40px", fontWeight: 200 }}>
          Book<span style={{ color: "#86c5da" }}>List</span> App
        </span>
      </div>

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          backgroundColor: "white",
          boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
        }}
      >
        <thead style={{ backgroundColor: "#dfe6f1", color: "#333" }}>
          <tr>
            <th style={{ padding: "12px", textAlign: "center" }}>Title</th>
            <th style={{ padding: "12px", textAlign: "center" }}>Author</th>
            <th style={{ padding: "12px", textAlign: "center" }}>ISBN</th>
            <th style={{ padding: "12px", textAlign: "center" }}>Genre</th>
            <th style={{ padding: "12px", textAlign: "center" }}>Publisher</th>
            <th style={{ padding: "12px", textAlign: "center" }}>Year</th>
            {(canEditBooks || canDeleteBooks) && (
              <th style={{ padding: "12px", textAlign: "center" }}>Action</th>
            )}
          </tr>
        </thead>
        <tbody>
          {books.map((b) => (
            <tr key={b.id} style={{ borderBottom: "1px solid #e0e0e0" }}>
              <td style={{ padding: "10px", textAlign: "center" }}>{b.title}</td>
              <td style={{ padding: "10px", textAlign: "center" }}>{b.author}</td>
              <td style={{ padding: "10px", textAlign: "center" }}>{b.isbn}</td>
              <td style={{ padding: "10px", textAlign: "center" }}>{b.genre}</td>
              <td style={{ padding: "10px", textAlign: "center" }}>{b.publisher}</td>
              <td style={{ padding: "10px", textAlign: "center" }}>
                {b.year_of_publication}
              </td>
              {(canEditBooks || canDeleteBooks) && (
                <td style={{ padding: "10px", textAlign: "center" }}>
                  {canEditBooks && (
                    <FaEdit
                      onClick={() => handleEdit(b)}
                      style={{
                        color: "#4682B4",
                        marginRight: "5px",
                        cursor: "pointer",
                      }}
                    />
                  )}
                  {canDeleteBooks && (
                    <FaTrash
                      onClick={() => handleDelete(b.id)}
                      style={{
                        color: "#B22222",
                        cursor: "pointer",
                      }}
                    />
                  )}
                </td>
              )}
            </tr>
          ))}
          {books.length === 0 && (
            <tr>
              <td colSpan={canEditBooks || canDeleteBooks ? "7" : "6"} style={{ textAlign: "center", padding: "15px", color: "gray", fontStyle: "italic" }}>
                No books found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}